import React, { useContext, useEffect, useState } from 'react'
export const TermsCmp = ({ addTerms }) => {
  
    function handleSelection(btn) {
        const idbtn = btn.target.id;
        if (idbtn == "idbtnok") {
            addTerms(true);
        } else {
            addTerms(false);    
        }
    }
    return (
        <div >
            <h2  className="text-1xl font-bold mb-10">ALGUNOS PUNTOS IMPORTANTES QUE DEBE CONOCER ANTES DE AGENDAR SU TURNO:</h2>
            <div className="text-left">
                <ul>
                    <li className="mb-5">
                        <strong >Plazo para la entrega de las fotos:</strong>
                        <ul>
                            <li>Embarazadas y bebés: mes y medio.</li>
                            <li>Niños y familias: 3 meses de estar antes el comercial le avisará.</li>
                            <li>Parejas: 3 meses de estar antes el comercial le avisará.</li>
                            <li>Quinceñeras: 3 meses.</li>
                        </ul>
                    </li>
                    <li className="mb-5">
                        <strong>Fotos sin editar:</strong> Solo se entregan las que usted escogió y pagó.
                    </li>
                    <li className="mb-5">
                        <strong>Tipo de fotos:</strong> Solo en formato digital, no impresas en papel.
                    </li>
                    <li className="mb-5">
                        <strong>Montajes:</strong> No se realizan montajes. Si no está de acuerdo con algo de la escenografía, debe decirlo en el momento de la sesión.
                    </li>
                    <li className="mb-5">
                        <strong>Sesiones en exterior:</strong> El transporte va por el cliente. Debe recoger a la fotógrafa y a la ayudante en el estudio y dirigirse al lugar seleccionado para las fotos.
                    </li>
                    <li className="mb-5">
                        <strong>Reserva:</strong> Para reservar, debe pagar un adelanto de 5 mlc que se descontará del precio total de la sesión al ser realizada. Siempre y cuando llegue puntual, si llega después de los 30 minutos, pierde ese derecho y pagará la oferta en su totalidad. Si desea cancelar, debe hacerlo con 7 días de antelación a su turno; si lo hace faltando menos de 7 días, el adelanto no se devolverá.
                    </li>
                    <li className="mb-5">
                        <strong>Pago:</strong> El pago en moneda nacional es al cambio en el momento de realizar la sesión, no en el momento de reservar. Los detalles del pago se le harán saber cuando el comercial le escriba en menos de 48 horas.
                    </li>
                </ul>
            </div>
            <div className="flex justify-center">
            <div style={{width:'50%'}} className="flex flex-col">
                <button id="idbtnok"className="btn btn-success mb-5" onClick={handleSelection}>De acuerdo</button>
                <button id="idbtnnop" className="btn btn-error" onClick={handleSelection}>No</button>
            </div>
            </div>
            
           
            
        </div>
    )
}
